<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat>
      <v-card-title class="background">
        Recognize a Coworker
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="form" v-model="valid">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <member-autocomplete
                v-model="user"
                :multiple="false"
                label="Coworker to Recognize"
                :rules="[$rules.requiredArrayWithoutFalsy]"
                allowAll
                placeholder="Search for a Coworker to Recognize"
                :memberIdsToNotShow="[profile.id]"
              >
              </member-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="linkedCoreValue"
                :label="`Related ${t('core_values.title_s')}`"
                :items="coreValueItems"
                outlined
                item-text="name"
                item-value="id"
              >
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea
                outlined
                v-model="recognition.text"
                label="Description"
                :rules="[$rules.required]"
                required
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-2">
          <v-row dense>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn color="success" :loading="saving" @click="save">
                Create
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import MemberAutocomplete from "@/components/members/MemberAutocomplete";
export default {
  name: "CreateRecognitionDialog",
  components: { MemberAutocomplete },
  props: {},
  data: () => ({
    dialog: false,
    valid: false,
    saving: false,
    recognition: {}
  }),
  watch: {},
  computed: {
    user: {
      get() {
        return [(this.recognition.user || {}).id || null];
      },
      set(val) {
        this.$set(this.recognition, "user", {});
        this.$set(this.recognition.user, "id", (val || [""])[0]);
      }
    },
    linkedCoreValue: {
      get() {
        if (this.recognition.isMission) {
          return "mission";
        }
        return this.recognition.coreValueId;
      },
      set(val) {
        this.recognition.isMission = val == "mission";
        this.recognition.coreValueId = val == "mission" ? null : val;
      }
    },
    coreValueItems() {
      let list = this.core_values.map(x => ({
        id: x.id,
        name: x.name
      }));
      list.unshift({ id: "mission", name: this.t("mission.title") });
      list.push({ id: null, name: "N/A" });
      return list;
    },
    ...mapGetters({
      core_values: "company/coreValues",
      profile: "profile/profile"
    })
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("recognition/saveRecognition", this.recognition)
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess("Recognition created");
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving your recognition."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    showDialog() {
      this.dialog = true;
      this.recognition = { text: "", coreValueId: null, isMission: true };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  }
};
</script>
